export default "__VITE_ASSET__0FS7LPKt__"